import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import Loading from '../Common/Loading';

interface SuperAdminRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ component: Component, ...rest }) => {
  const { admin, loading, isSuperAdmin } = useAdminAuth();
  
  if (loading) {
    return <Loading />;
  }
  
  return (
    <Route
      {...rest}
      render={(props) =>
        admin && isSuperAdmin ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: admin ? "/admin/dashboard" : "/admin/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default SuperAdminRoute;